import { Box, Dialog, DialogContent } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import CloseIcon from "../../../../../../assets/images/icons/CloseIcon";
import BriaButton from "../../../../../../components/common/BriaButton/BriaButton";
import VideoEraserPopupConfig from "./Config/VideoEraserPopupConfig";
import VideoEraserPopupPreview from "./Preview/VideoEraserPopupPreview";
import styles from "./VideoEraserPopup.module.scss";

export type ActiveTab = "prompt" | "keyPoints" | "upload";

type VideoEraserPopupProps = {
	open: boolean;
	onClose: () => void;
};

const VideoEraserPopup = ({ open, onClose }: VideoEraserPopupProps) => {
	const { t } = useTranslation("video_editing", { keyPrefix: "lab.config.tools.erase.popup" });
	const [activeTab, setActiveTab] = useState<ActiveTab | undefined>("prompt");

	return (
		<>
			<Dialog open={open} onClose={onClose} fullWidth PaperProps={{ className: styles.dialog }}>
				<BriaButton
					buttonType="textSmall"
					startIcon={<CloseIcon />}
					onClick={onClose}
					className={styles.closeIcon}
				>
					{t("close")}
				</BriaButton>
				<DialogContent onClick={(e) => e.stopPropagation()} className={styles.dialogContent}>
					<Box className={styles.content}>
						<VideoEraserPopupConfig {...{ activeTab, setActiveTab }} />
						<VideoEraserPopupPreview {...{ activeTab, setActiveTab }} closePopup={onClose} />
					</Box>
				</DialogContent>
			</Dialog>
		</>
	);
};

export default observer(VideoEraserPopup);
